import { clubLandDrawHint } from '../utils/clubBoundaryRole';

import './clubLandRoleToggle.css';

export function ClubLandRoleToggle({ isBoundary, onChange }) {
  const tool = isBoundary !== false ? 'boundary' : 'field';
  return (
    <div className="club-land-role" data-testid="club-land-role">
      <div className="club-land-role__row" role="group" aria-label="Boundary or field">
        <button
          type="button"
          className={`club-land-role__btn${tool === 'boundary' ? ' is-active' : ''}`}
          aria-pressed={tool === 'boundary'}
          data-testid="club-land-role-boundary"
          onClick={() => onChange(true)}
        >
          Boundary
        </button>
        <button
          type="button"
          className={`club-land-role__btn${tool === 'field' ? ' is-active' : ''}`}
          aria-pressed={tool === 'field'}
          data-testid="club-land-role-field"
          onClick={() => onChange(false)}
        >
          Field
        </button>
      </div>
      <p className="club-land-role__hint" data-testid="club-land-role-hint">
        {clubLandDrawHint(tool)}
      </p>
    </div>
  );
}
